import Image from 'next/image'
import Container from 'react-bootstrap/Container';
import styles from './LandingPageHero.module.scss';
import defaultCoverPhoto from '../public/images/online-tutoring-bg-2.jpg';
import HeroSearch from './HeroSearch'

export default function LandingPageHero({page}) {
  const backgroundStyle = {
    backgroundImage: page.coverPhoto.url || defaultCoverPhoto.src
  }

  return (
    <div className={styles.container}>
      <div className={styles.overlay}></div>

      <Image
        src={backgroundStyle.backgroundImage}
        className={styles.staticBg}
        alt="Cover photo"
        priority
        fill
        sizes="100vw"
        style={{
          objectFit: "cover",
          objectPosition: "center"
        }} />

      <Container className={`${styles.content} pt-lg-4`}>
        <div className="pb-2 pt-5 pb-lg-4 text-center">
          <h1 className="text-white pb-2">
            {page.header1}
          </h1>
          <p className="h5 text-white">
            {page.subheader}
          </p>
        </div>

        {page.showSearch &&
          <div className="pt-2 mb-5">
            <div className={`${styles.searchContainer} p-3 p-lg-5`}>
              <HeroSearch
                subject={page.subject}
                level={page.level}
                location={page.marketingLocation}
                modality={page.modality}
              />
            </div>
          </div>
        }
      </Container>
    </div>
  )
}
